"use client";
import Typography from "@/components/common/typography";
import Button from "@/components/common/button";

import React from "react";

interface SeeMyPriceSearchFieldProps {
  buttonLabel: string;
  searchFieldLabel: string;
}
const SeeMyPriceSearchField: React.FC<SeeMyPriceSearchFieldProps> = ({
  buttonLabel,
  searchFieldLabel,
}) => {
  return (
    <a href="#"  data-panda-price-modal>
      <div className=" bg-secondary rounded-cardXl p-2.5 md:p-3 flex justify-between max-w-521px">
      <span className="w-fit py-7px flex gap-5px items-center rounded-full ml-3 ">
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 14.5L10.0001 10.5M11.3333 7.16667C11.3333 9.744 9.244 11.8333 6.66667 11.8333C4.08934 11.8333 2 9.744 2 7.16667C2 4.58934 4.08934 2.5 6.66667 2.5C9.244 2.5 11.3333 4.58934 11.3333 7.16667Z"
            stroke="#9399A6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <Typography size="body2" color="neoGray">
          {searchFieldLabel}
        </Typography>
      </span>
      
      <Button
  
        className=" !rounded-cardXl !px-2.5 !max-w-36 md:!max-w-52 md:!px-12 "
        intent="primary"
        label={buttonLabel}
        onClick={() => {}}
      />
    </div>
    </a>
    
  );
};

export default SeeMyPriceSearchField;
